/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavController } from '@ionic/angular';

import { StorageProvider } from '../../services/storage.provider';
import { ArticlesService } from '../../services/articles.service';
import { Logout } from '../../services/logout.provider';
import { Coupon } from '../../models/coupon.model';

import { Profile } from '../../models/profile.model';
import { ConfigService } from '../../services/config.service';
import { Multitenant } from '../../services/multitenant.provider';

@Component({
  selector: 'app-apply-coupon',
  templateUrl: 'apply-coupon.html',
  styleUrls: ['apply-coupon.scss']
})
export class ApplyCouponPage implements OnInit {
  public access_token: string;
  public profiles: any = [];
  public proflen: any;
  public error: boolean;
  public selectedd: number;
  public couponModel: Coupon = new Coupon();
  private coupon: string;
  private parent: Profile;
  public valid: boolean;
  public error_coupon: string;
  public couponDetails: Coupon;
  public errorAddCoupon: string;
  public errorAddCouponCounter: Array<string> = [];
  private profileSelectedCounter = 0;
  public message: string;
  public messageSuccess: string;
  public couponNews: Array<string> = [];
  public duration: string;
  public newspaperList: string;

  constructor(
    public navCtrl: NavController,
    private actRoute: ActivatedRoute,
    private router: Router,
    private storage: StorageProvider,
    private articlesService: ArticlesService,
    private logout: Logout,
    private config: ConfigService,
    protected platform: Multitenant
  ) { }

  ngOnInit(): void {
    const code = document.URL.split('/');
    if(code[4]){
      this.coupon = code[4];
      this.couponModel.coupon_code = this.coupon;
    }
    if(this.storage.getStorage('coupon')){
      this.couponModel.coupon_code = this.storage.getStorage('coupon');
    }
    const profile_type = this.storage.getStorage('logged_profile_type');

    this.actRoute.queryParamMap.subscribe(
      params => {
        this.access_token = params.get('access_token') ? params.get('access_token') : this.storage.getStorage('access_token');

        if(!this.access_token) {
          this.storage.setSessionStorage('coupon', this.coupon);
          window.setTimeout(() => {this.router.navigate(['connexion']); }, 1000);
        } else if(this.access_token && profile_type !== 'Parent'){
          this.articlesService.getUserProfiles(this.access_token).subscribe(
            response => {
              response.profiles.forEach(
                profile => {
                  if(profile.profile_type === 'Parent') {
                    this.parent = profile;
                    this.router.navigate(['loginprofile'], { queryParams: { parent: JSON.stringify(this.parent) } } );
                  }
                }
              );
            }
          );
        }
      }
    );
  }

  ionViewWillEnter() {
    this.valid = false;
  }

  logOut() {
    this.logout.logOut();
    this.router.navigate(['']);
  }

  isLogin() {
    return 'login';
  }

  setSelected(id) {
    this.profiles.forEach( (profile, index) => {
      if (index === id) {
        if (!profile.selected) {
          profile.selected = true;
        } else {
          profile.selected = false;
        }
      }
    });
  }

  applyCode() {
    const self = this;
    const selectedProfiles: Array<string> = [];
    this.profiles.forEach((profile) => {
      if (profile.selected) {
        self.profileSelectedCounter += 1;
        selectedProfiles.push(profile.profile_firstName);

        self.articlesService.addPromoCode(self.couponModel.coupon_code, profile.profile_id, self.access_token).subscribe(
          () => {},
          (error) => {
            self.errorAddCoupon = error.message;
            self.errorAddCouponCounter.push(profile.profile_firstName);
          }
        );
      }
    });

    if (this.errorAddCouponCounter.length !== this.profileSelectedCounter) {
      self.couponDetails.coupon_code = this.couponModel.coupon_code;
      this.router.navigate(
        ['about'],
        {
          queryParams: {
            page: 'coupons',
            couponDetails: JSON.stringify(self.couponDetails),
            profileErrors: JSON.stringify(this.errorAddCouponCounter),
            applyedProfile: JSON.stringify(selectedProfiles)
          }
        }
      );
    }
  }

  checkCode() {
    const self = this;
    this.error_coupon = '';
    const coupon = this.couponModel.coupon_code;
    this.resetData();
    this.error_coupon = null;
    this.articlesService.checkPormoCode(coupon).subscribe(
      (response) => {
        this.valid = true;
        this.error = false;
        this.couponDetails = response[0];
        if (response[0].profiles_allowed) {
          this.profiles = response[0].profiles_allowed;
          for (const property in response[0].newspapers) {
            self.couponNews.push(self.config.getSeoConfig()[property].name);
          }
          this.duration = response[0].duration;
          this.newspaperList = self.couponNews.join(', ');
        } else {
          this.profiles = [];
          if (this.platform.getDomainClass() === 'mwjp') {
            this.error_coupon = '申し訳ありませんが、このコードはどのプロフィールにも適用できません。';
          } else if (this.platform.getDomainClass() === 'mwde') {
            this.error_coupon = 'Leider kann Ihr Code keinem Profil zugeordnet werden';
          } else {
            this.error_coupon = 'Désolé, votre code ne peut être appliqué sur aucun profil.';
          }
          this.valid = false;
        }
      },
      (error) => {
        if (this.platform.getDomainClass() === 'mwjp') {
          this.error_coupon = 'コードが無効です。';
        } else if (this.platform.getDomainClass() === 'mwde') {
          this.error_coupon = 'Ungültiger Code';
        } else {
          this.error_coupon = 'Code invalide';
        }
      }
    );
  }

  changeHandler() {
    if (!this.couponModel.coupon_code) {
      this.error_coupon = '';
    }
  }

  resetData() {
    this.profiles = [];
    this.messageSuccess = '';
    this.message = '';
    this.valid = false;
  }
}
